import { Link } from 'react-router-dom';
import { FaGraduationCap, FaPhone, FaEnvelope, FaMapMarkerAlt, FaHeart } from 'react-icons/fa';
import SocialLinks from './SocialLinks';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <h3 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <FaGraduationCap size={20} /> <span>SBS</span> Institute of Coaching
          </h3>
          <p>
            Empowering students with quality education for IX–XII, Graduation &amp;
            Competitive Exams. Your success is our mission.
          </p>
          <div style={{ marginTop: '1.2rem' }}>
            <SocialLinks variant="footer" size={18} />
          </div>
        </div>

        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            {[['/', 'Home'], ['/courses', 'Courses'], ['/notes', 'Study Notes'], ['/gallery', 'Gallery'], ['/videos', 'Demo Classes']].map(([to, label]) => (
              <li key={to}><Link to={to}>{label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Contact Us</h4>
          <ul>
            <li>
              <a href="tel:+918077623711" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FaPhone size={12} /> +91 8077623711
              </a>
            </li>
            <li>
              <a href="tel:+917417652434" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FaPhone size={12} /> +91 7417652434
              </a>
            </li>
            <li>
              <a href="mailto:sbsinstitute711@gmail.com" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FaEnvelope size={12} /> sbsinstitute711@gmail.com
              </a>
            </li>
            <li>
              <Link to="/contact" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FaMapMarkerAlt size={12} /> Muzaffarnagar, UP – 251002, India
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem', flexWrap: 'wrap' }}>
          © {new Date().getFullYear()} SBS Institute of Coaching. All rights reserved. | Designed with <FaHeart size={12} color="#EF4444" /> for students
        </p>
      </div>
    </footer>
  );
}
